<template>
    <div>
        <div style="margin-bottom: 10px;">
            <el-alert title="平台鼓励原创，请制作自己视频，勿搬运他人视频" type="info" effect="dark" show-icon style="margin-bottom: 10px;">
            </el-alert>
            <div
                style="margin:0 0 1.5vh 0;display: flex;flex-wrap: wrap;justify-content: space-between;align-items: center;">
                <div style="font-weight: 600;font-size: 1.7vh;">上传方式 (可交替使用)</div>
                <div style="display: flex;align-items: center;color: #444;">
                    <!-- <div style="display: flex;align-items: center;">
                        <div style="font-size: 12px;">不清空链接</div>
                        <el-switch v-model="clear_url_status" style="margin-left: 5px;" active-color="#67c23a">
                        </el-switch>
                    </div> -->
                    <!-- <div v-if="from == 'qc'"
                        style="background-color: #f1f1f1;font-size: 12px;padding: 5px 10px;border-radius: 4px;margin: 2px 3px;cursor: pointer;"
                        class="no-select"
                        :style="{ 'background-color': tietu_status ? '#67c23a' : '#f1f1f1', 'color': tietu_status ? '#fff' : '#444' }"
                        @click="tietu_status = !tietu_status">
                        贴图模式
                    </div> -->
                    <div style="background-color: #f1f1f1;font-size: 12px;padding: 5px 10px;border-radius: 4px;margin: 2px 3px;cursor: pointer;"
                        class="no-select"
                        :style="{ 'background-color': clear_url_status ? '#67c23a' : '#f1f1f1', 'color': clear_url_status ? '#fff' : '#444' }"
                        @click="clear_url_status = !clear_url_status">
                        不清空链接: {{ clear_url_status ? '开启' : '关闭' }}
                    </div>
                </div>
            </div>
            <div style="display: flex;background-color: #c0c4cc;border-radius: 3vh;">
                <div class="no-select"
                    style="width: 50%;text-align: center;padding: 1vh;background-color: #484add;color: #fff;border-radius: 3vh ;font-weight: 600;font-size: 1.4vh;"
                    :style="{
                        'background-color': upload_type == 1 ? '#484add' : '#c0c4cc',
                        'color': upload_type == 1 ? '#fff' : '#444'
                    }" @click="upload_type = 1">
                    链接上传
                </div>
                <div class="no-select"
                    style="width: 50%;text-align: center;padding: 1vh;background-color: #c0c4cc;color: #555;border-radius: 3vh ;font-weight: 600;font-size: 1.4vh;"
                    :style="{
                        'background-color': upload_type == 2 ? '#484add' : '#c0c4cc',
                        'color': upload_type == 2 ? '#fff' : '#444'
                    }" @click="upload_type = 2">
                    视频上传
                </div>
            </div>
        </div>
        <!-- :on-remove="upload_remove" -->
        <div class="upload2" style="margin-bottom: 10px;" v-if="upload_type == 2">
            <div style="margin:0 0 1.5vh 0;font-weight: 600;font-size: 1.7vh;">视频上传</div>
            <el-upload drag action="#" ref="upload" :limit="limit_url" :before-upload="upload_fast"
                :file-list="url_list" :on-exceed="upload_xianzhi" :show-file-list="false"
                :accept="'.mp4,.mov' + (tietu_status ? ',image/*' : '')" :http-request="upload_duilie" multiple>
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传视频文件，且单个不超过600MB，数量限制200个</div>
            </el-upload>
        </div>

        <div style="margin-bottom: 10px;" v-if="upload_type == 1">
            <div style="margin:0 0 1.5vh 0;font-weight: 600;font-size: 1.7vh;">链接上传</div>
            <el-input type="textarea" v-model="inputurl" placeholder="一行一个链接,回车换行"
                :autosize="{ minRows: 7, maxRows: 7 }">
            </el-input>
            <div style="display: flex;">
                <el-button type="primary"
                    style="width: 50%;margin-top: 10px;background-color: #464646;border-color: #464646;" size="small"
                    @click="getClipboardText()" icon="el-icon-document-copy">粘贴</el-button>
                <el-button type="primary"
                    style="width: 50%;margin-top: 10px;background-color: #67c23a;border-color: #67c23a;" size="small"
                    @click="url_jc" icon="el-icon-document-checked">确认链接</el-button>
            </div>
        </div>

        <div v-if="url_list.length > 0">
            <div
                style="margin: 1.5vh 0;font-weight: 600;font-size: 1.7vh;display: flex;justify-content: space-between;align-items: center;">
                已上传视频列表
                <!-- <div style="font-weight: 500;font-size: 1.5vh;color: #ce2b2b;cursor: pointer;" @click="url_list = []">
                    一键清空</div> -->
            </div>
            <div class="scroll-container"
                style="padding: 8px; background-color: #f5f5f5; border-radius: 1vh; color: #666; font-size: 13px; max-height: 21vh; overflow-y: auto;">
                <div v-for="(item, index) in url_list" :key="index"
                    style="display: flex; align-items: center; padding: 6px;">
                    <div
                        style="display: flex; align-items: center; justify-content: center; background-color: #484add; color: #fff; border-radius: 10px; font-size: 12px; width: 18px; height: 18px; margin-right: 6px;">
                        {{ index + 1 }}
                    </div>
                    <div style="margin-right: 5px;color: #1a9c34;" v-if="item.zt == 'uploading'">
                        <i class="el-icon-loading"></i>
                        {{ item.percentage }}
                    </div>
                    <div
                        style="white-space: nowrap; display: block; overflow: hidden; text-overflow: ellipsis; flex: 1; font-size: 13px;">
                        {{ item.filename || item.url }}
                    </div>

                    <div style="margin-right: 4px; font-size: 1.5vh; color: #1a9c34;" v-if="item.zt == 'success'">
                        已上传
                    </div>
                    <div style="margin-right: 4px; font-size: 1.5vh; color: #ff1031;" v-if="item.zt == 'error'">
                        {{ item.error_info ? item.error_info : '失败' }}
                    </div>
                    <div style="margin-left: 5px;" @click="del_url(index)">
                        <i class="el-icon-circle-close" style="font-size: 19px; cursor: pointer;"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CryptoJS from 'crypto-js';
import COS from "cos-js-sdk-v5";
export default {
    name: 'qhyupload',
    components: {},
    props: {
        limit_url: {
            type: Number,
            default: 200
        },
        from: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            upload_type: 1,
            inputurl: '',
            spnum: 0,
            video_num: 0,
            videoFileList: [],
            upload_info: false,
            uploadedChunks: {},
            url_list: [],
            uploadQueue: [], // 上传队列
            isUploading: false, // 标志位，指示是否有文件正在上传
            clear_url_status: false,
            tietu_status: false,
            use_cos: 1
        }
    },
    methods: {
        clear_url() {
            if (this.clear_url_status) return
            this.url_list = []
        },
        async getClipboardText() {
            try {
                let text = await navigator.clipboard.readText();
                // 识别到文本内有douyin替换为duoying
                // if (text && text.includes('douyin')) {
                //     text = text.replace(/douyin/gi, 'duoying');
                // }
                console.log('剪切板内容:', text);
                this.inputurl = text
                // 在这里你可以将获取到的文本用于你的应用逻辑
            } catch (err) {
                console.error('无法读取剪切板内容:', err);
            }
        },
        get_urls(islist = 0) {
            var urls = islist == 0 ? '' : []
            for (var i = 0; i < this.url_list.length; i++) {
                if (this.url_list[i].zt == 'uploading') {
                    return { status: 100, msg: '请等待视频上传完成，或取消上传' }
                }
                if (this.url_list[i].zt == 'error') {
                    continue;
                }
                if (islist == 0) {
                    urls += this.url_list[i].url + '\n'
                } else {
                    urls.push(this.url_list[i])
                }
            }
            if (urls.length < 1) {
                return { status: 100, msg: '可制作视频为空，请先上传视频' }
            }
            return urls
        },
        del_url(index) {
            this.$confirm('确定删除' + this.url_list[index].url + ', 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                customClass: 'newdialog',
                type: 'warning'
            }).then(() => {
                const fileWithController = this.url_list[index];
                if (fileWithController.zt == 'uploading') {
                    console.log(fileWithController)
                    if (fileWithController.abortController) {
                        fileWithController.abortController.abort();
                    }
                }
                const urlindex = this.uploadQueue.findIndex(f => f.uid === fileWithController.uid)
                if (urlindex !== -1) {
                    this.uploadQueue.splice(urlindex, 1);
                }
                this.url_list.splice(index, 1);
            });
        },
        url_jc() {

            const lines = this.inputurl.trim().split('\n').filter(line => line.trim() !== '');
            console.log(lines)
            for (let index = 0; index < lines.length; index++) {
                if (this.url_list.length >= this.limit_url) {
                    this.$toast.show("最多上传" + this.limit_url + "个链接", 2000);
                    return;
                }
                this.url_list.push({ url: lines[index], 'zt': 'success' });
            }
            this.$toast.show("识别有效链接" + lines.length + "个", 2000);
            this.inputurl = ''
            // this.urlnum = lines.length;
            // console.log(this.urlnum);
        },
        upload_fast(file) {
            const validTypes = this.tietu_status
                ? ['video/mp4', 'video/quicktime', 'image/*']
                : ['video/mp4', 'video/quicktime'];

            let isValidType = false;

            // 判断文件类型有效性（支持 image/* 通配符匹配）
            isValidType = validTypes.some(type => {
                if (type === 'image/*') {
                    return file.type.startsWith('image/');
                } else {
                    return file.type === type;
                }
            });

            // 文件类型校验失败处理
            if (!isValidType) {
                const errorMsg = this.tietu_status
                    ? `${file.name} 文件类型不支持，只允许 mp4、mov 或图片格式！`
                    : `${file.name} 视频只能是 mp4 或 mov 格式！`;
                this.$message.error(errorMsg);
                return false;
            }
            // 新增：图片数量限制检查（仅针对图片类型文件）
            if (file.type.startsWith('image/')) {
                console.log(this.url_list)
                const existingImagesCount = this.url_list.filter(item => item.filetype && item.filetype.startsWith('image/')).length;
                if (existingImagesCount >= 1) {
                    this.$message.error('贴图模式只能上传一张图片，请删除后再上传');
                    return false;
                }
            }
            // 文件大小校验（600MB限制）
            const maxSize = 600 * 1024 * 1024;
            if (file.size > maxSize) {
                this.$message.error(`${file.name} 文件大小不能超过 600MB！`);
                return false;
            }

            return true;
        },
        upload_xianzhi(files, fileList) {
            this.$message.warning(`当前限制选择 ${this.limit_url} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        upload_change(file, fileList) {

            if (!this.videoFileList.some(f => f.uid === file.uid)) {
                // file.start = 'uploading'
                this.videoFileList.push(file);
            }
            this.video_num = fileList.length;
        },
        async upload_duilie(options) {
            const { file } = options;
            file.fileHash = await this.generateFileHash(file);
            if (!this.url_list.some(f => f.uid === file.uid)) {
                this.url_list.push({
                    uid: file.uid, url: '', 'percentage': '准备开始上传', zt: 'uploading', filename: file.name, filetype: file.type
                });
            }
            try {
                const timestamp = Math.floor(Date.now() / 1000);
                if (this.upload_info && timestamp - this.upload_info.time > this.upload_info.max_time) {
                    this.upload_info = false;
                }
                if (!this.upload_info) {
                    this.upload_info = await this.getUploadUrl();
                }
                if (this.upload_info) {
                    // this.upload_info.upload_url = 'https://localhost:9991/upload_chunk.php';
                    this.uploadQueue.push(file); // 将文件添加到上传队列
                    this.processUploadQueue(); // 处理上传队列
                } else {
                    this.isUploading = false;
                    this.update_file(file, 'error', '获取上传地址失败')
                }
            } catch (error) {
                this.$message.error(`获取上传地址失败: ${error.message}`);
                this.isUploading = false;
                this.update_file(file, 'error', '获取上传地址失败')
            }
        },
        processUploadQueue() {
            if (this.isUploading || this.uploadQueue.length === 0) {
                return; // 如果正在上传或队列为空，直接返回
            }

            this.isUploading = true; // 设置标志位为正在上传
            const file = this.uploadQueue.shift(); // 从队列中取出第一个文件
            if (this.use_cos) {
                this.cos_uploadFile(file, this.upload_info);
            } else {
                this.upload_file(file, this.upload_info);
            }
        },
        async getUploadUrl() {
            try {
                const response = await this.$ajax.post('/qhy/app/upload_dz', {
                    num: 1,
                    xgcs: 1,
                }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                console.log(response.data);
                if (response.data.status == 200) {
                    return response.data.data;
                } else {
                    this.$message.error(response.data.msg);
                    return false;
                }
            } catch (error) {
                return false;
            }
        },
        generateFileHash(file) {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                const blob = file.slice(0, 1024 * 1024); // 读取前1MB
                reader.onload = (event) => {
                    const fileContent = event.target.result;
                    const originalHash = CryptoJS.SHA256(fileContent + file.name + file.size + file.lastModified).toString();
                    const finalHash = originalHash.length >= 15
                        ? originalHash.slice(-15) // 截取最后15位
                        : originalHash; // 不足15位则保留原字符串
                    resolve(finalHash);
                };
                reader.onerror = (error) => {
                    reject(error);
                };
                reader.readAsArrayBuffer(blob);
            });
        },
        async upload_file(file, upload_data) {
            console.log('开始上传信息', upload_data, file);
            const urlindex = this.url_list.findIndex(f => f.uid === file.uid)
            const chunkSize = 1024 * 1024; // 1MB
            const totalChunks = Math.ceil(file.size / chunkSize);
            let currentChunk = 0;

            const abortController = new AbortController();
            // file.abortController = abortController;
            this.url_list[this.url_list.findIndex(f => f.uid === file.uid)].abortController = abortController;
            console.log('分片数量', totalChunks);
            this.url_list[this.url_list.findIndex(f => f.uid === file.uid)].percentage = '上传中1%';
            // 获取已上传的分片信息
            try {
                const response = await this.$ajax_upload.post(upload_data.upload_url, {
                    fileHash: file.fileHash,
                    filename: file.name,
                    totalChunks: totalChunks,
                    action: 'get_uploaded_chunks',
                    token: upload_data.token,
                }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
                console.log(response.data);
                if (response.data.code === 200) {
                    if (response.data.dz) {
                        this.update_file(file, 'success', response.data.dz)
                        return
                    }
                    this.uploadedChunks[file.fileHash] = response.data.uploadedChunks || [];
                    if (this.uploadedChunks[file.fileHash].length > 0) {
                        currentChunk = Math.max(...this.uploadedChunks[file.fileHash]) + 1;
                    }
                    console.log('已上传分片信息', this.uploadedChunks[file.fileHash]);
                } else {
                    throw new Error(response.data.msg);
                }
            } catch (error) {
                this.$message.error(`获取已上传分片信息失败: ${error.message}`);
                this.update_file(file, 'error', error.message)
                return;
            }

            const uploadChunk = () => {
                const start = currentChunk * chunkSize;
                const end = Math.min(file.size, start + chunkSize);
                const chunk = file.slice(start, end);

                const formData = new FormData();
                formData.append('file', chunk);
                formData.append('filename', file.name);
                formData.append('chunk', currentChunk);
                formData.append('totalChunks', totalChunks);
                formData.append('fileHash', file.fileHash); // 添加文件哈希值
                formData.append('token', upload_data.token);
                console.log('开始上传', currentChunk)
                this.$ajax_upload.post(upload_data.upload_url, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    signal: abortController.signal
                }).then(response => {
                    console.log(response.data);
                    if (response.data.code === 201) {
                        console.log(this.url_list.findIndex(f => f.uid === file.uid))
                        if (this.url_list[this.url_list.findIndex(f => f.uid === file.uid)]) {
                            this.url_list[this.url_list.findIndex(f => f.uid === file.uid)].percentage = '上传中' + ((currentChunk + 1) * (100 / totalChunks)).toFixed(0) + '%';
                        } else {
                            throw new Error('上传已取消');
                        }
                        this.uploadedChunks[file.fileHash].push(currentChunk);
                    }
                    currentChunk++;
                    if (currentChunk >= totalChunks) {
                        if (response.data.code === 200) {
                            this.update_file(file, 'success', response.data.dz)
                        } else {
                            this.update_file(file, 'error', response.data.msg)
                        }
                        return;
                    } else {
                        uploadChunk();
                    }

                }).catch(error => {
                    console.log(error)
                    if (error.message == 'canceled') {
                        this.$message.error(`${file.name} 已取消上传`);
                    } else {
                        this.$message.error(`${file.name} ${error.message}`);
                    }
                    this.update_file(file, 'error', error.message)
                });
            };
            uploadChunk();
        },
        update_file(file, type, dz) {
            const index = this.url_list.findIndex(f => f.uid === file.uid);
            if (index !== -1) {
                if (type === 'success') {
                    this.$message.success(`${file.name} 上传成功!`);
                    this.url_list[index].url = dz;
                    this.url_list[index].zt = type;
                } else if (type === 'error') {
                    this.url_list[index].zt = type;
                    this.url_list[index].error_info = dz;
                }
                delete this.url_list[index].abortController;
            }
            this.isUploading = false;
            this.processUploadQueue();
        },
        async cos_uploadFile(file) {

            console.log(file)
            var that = this
            var taskId = '';
            const res = await this.$ajax.post('/qhy/user/upload_dz_cos', {
                type: file.type,
                filename: file.name,
                hash: file.fileHash,
            }, { headers: { 'Content-Type': 'application/x-www-form-urlencoded' } });
            console.log(res.data);
            if (res.data.status == 200) {
                let cosf = new COS({
                    SecretId: res.data.data.Credentials.TmpSecretId,
                    SecretKey: res.data.data.Credentials.TmpSecretKey,
                    SecurityToken: res.data.data.Credentials.Token,
                    StartTime: res.data.data.startTime,
                    ExpiredTime: res.data.data.ExpiredTime,
                });
                //判断文件是否存在
                try {
                    const filehave = await cosf.headObject({
                        Bucket: res.data.data.bucket,
                        Region: res.data.data.region,
                        Key: res.data.data.dz,
                    });
                    this.update_file(file, 'success', res.data.data.down_dz)
                    return
                } catch (err) {
                }
                cosf.uploadFile({
                    Bucket: res.data.data.bucket, /* 填入您自己的存储桶，必须字段 */
                    Region: res.data.data.region,  /* 存储桶所在地域，例如ap-beijing，必须字段 */
                    Key: res.data.data.dz,  /* 存储在桶里的对象键（例如1.jpg，a/b/test.txt），必须字段 */
                    Body: file, /* 必须，上传文件对象，可以是input[type="file"]标签选择本地文件后得到的file对象 */
                    SliceSize: 1024 * 1024 * 5,// 触发分块上传的阈值
                    ChunkSize: 1024 * 1024, // 分块大小，默认 1MB，非必须
                    onTaskReady(id) {
                        taskId = id;
                    },
                    onProgress: function (progressData) {
                        console.log(JSON.stringify(progressData));
                        let percent = Math.round(progressData.percent * 100);
                        let loaded = Math.round(progressData.loaded / 1024 / 1024);
                        let total = Math.round(progressData.total / 1024 / 1024);
                        let speed = Math.round(progressData.speed / 1024 / 1024);
                        console.log(that.url_list.findIndex(f => f.uid === file.uid))
                        if (that.url_list[that.url_list.findIndex(f => f.uid === file.uid)]) {
                            that.url_list[that.url_list.findIndex(f => f.uid === file.uid)].percentage = '上传中' + percent + '% (' + `${loaded}MB/${total}MB ${speed}MB/s)`;
                        } else {
                            console.log('用户取消上传', taskId)
                            cosf.cancelTask(taskId);
                            that.update_file(file, 'error', '用户取消上传')
                        }
                    }
                }, function (err, data) {
                    if (err) {
                        console.log('上传失败', err);
                        that.update_file(file, 'error', String(err))
                    } else {
                        console.log('上传成功', data);
                        that.update_file(file, 'success', res.data.data.down_dz)
                    }
                });
            } else {
                this.$message.error(res.data.msg);
                return false;
            }


        },
    }
}
</script>

<style scoped>
.upload2 .el-upload {
    width: 100%;
}

.upload2 .el-upload-dragger {
    width: 100%;
}

.scroll-container::-webkit-scrollbar {
    width: 5px;
    /* 滚动条宽度 */
}

.scroll-container::-webkit-scrollbar-track {
    background: #f1f1f1;
    /* 滚动条轨道背景色 */
}

.scroll-container::-webkit-scrollbar-thumb {
    background: #888;
    /* 滚动条滑块背景色 */
    border-radius: 4px;
    /* 滚动条滑块圆角 */
}

.scroll-container::-webkit-scrollbar-thumb:hover {
    background: #555;
    /* 滚动条滑块悬停背景色 */
}
</style>


// WEBPACK FOOTER //
// src/components/common/qhyupload.vue